import { jsx, jsxs } from "react/jsx-runtime";
import { formatMinorUnits } from "@seek/currency";
import { useTranslations } from "@vocab/react";
import { Box, Stack, Badge } from "braid-design-system";
import { translations } from "../../../../components/BudgetOption/Features/.vocab/index.mjs";
import { invisibleBadgeBox } from "./DiscountBadges.css.mjs";
const getAmountLabel = (discount, currency, locale) => {
  if (discount.type === "FixedAmount") {
    return formatMinorUnits(discount.value, {
      currency,
      locale,
      dropFraction: true
    });
  }
  if (discount.type === "Percentage") {
    return `${discount.value}%`;
  }
  return "";
};
const DiscountBadges = ({
  discounts,
  currency,
  locale,
  discountPadding
}) => {
  const { t } = useTranslations(translations);
  const padding = Array.from({ length: discountPadding ?? 0 }, (_, index) => /* @__PURE__ */ jsx(Box, { className: invisibleBadgeBox }, index));
  return /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
    discounts && discounts.map((discount, i) => {
      const { adType } = discount;
      return /* @__PURE__ */ jsx(Badge, { tone: "promote", children: t("Amount off budgetType", {
        amount: getAmountLabel(discount, currency, locale),
        budgetType: adType,
        budgetTypePostFix: adType === "Branded" || adType === "StandOut" ? adType : "other"
      }) }, `${adType.toLowerCase}-badge-${i}`);
    }),
    padding
  ] });
};
export {
  DiscountBadges
};
